module.exports = __webpack_public_path__ + "img/order.ee1521d0.svg";